export default __webpack_public_path__ + "static/media/green_tick.1e844f43.svg";